import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { TablePagination } from '@material-ui/core';
import {
  getPage,
  getPerPage,
  getTotal,
} from '../../../state/reducers/ApplicationReducer';
import ApplicationActions from '../../../state/actions/ApplicationActions';

function ApplicationsPagination(props) {
  let { total, page, perPage, setPage, setPerPage } = props;
  let { t } = useTranslation();
  function onChangePage(e, page) {
    e && e.stopPropagation();
    if (page < 0 || page > (Math.ceil(total / perPage) || 1) - 1) {
      return;
    }
    setPage(page);
  }
  function onChangeRowsPerPage(e) {
    setPerPage(e.target.value);
  }

  return (
    <TablePagination
      page={page}
      rowsPerPage={perPage}
      labelRowsPerPage={t('rowsPerPage')}
      count={Number(total)}
      onPageChange={onChangePage}
      onRowsPerPageChange={onChangeRowsPerPage}
      component="span"
    />
  );
}

export default compose(
  connect(
    (state) => ({
      page: getPage(state),
      perPage: getPerPage(state),
      total: getTotal(state),
    }),
    {
      setPage: ApplicationActions.setPage,
      setPerPage: ApplicationActions.setPerPage,
    }
  )
)(ApplicationsPagination);



// WEBPACK FOOTER //
// ./src/view/scenes/Applications/ApplicationsPagination.js